import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-shadow: ${themeGet('shadows.header')};

  &:not(:last-child) {
    margin-bottom: 54px;
  }
`;
